import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/pro-solid-svg-icons";
export default function Loader() {
  return (
    <div className="w-full h-full backdrop-grayscale bg-white/30 absolute z-1200 flex items-center justify-center">
      <FontAwesomeIcon
        icon={faCircleNotch}
        className="text-primary animate-spin fa-5x"
      />
    </div>
  );
}
